import { ShowItem, ItemManager } from "./showItem";
import { ReactNode } from 'react';
import MedicationIcon from '@mui/icons-material/Medication';
import { getAwareColor } from '../utils/aware';

export class Drug implements ShowItem {
    code: number;
    title: string;
    ref?: number;
    class: string;
    therapeutic_indications: string;
    dosage_normal: string;
    dosage_30_50: string;
    dosage_10_30: string;
    extra: boolean;
    classId: string;

    constructor(csvArray: string[]) {
        if(csvArray.length !== 9) {
            throw new Error(`Invalid CSV array length for Drug: ${csvArray.length}`);
        }

        this.code = parseInt(csvArray[0]);
        // this.ref = parseInt(csvArray[1]);
        this.class = csvArray[1];
        this.title = csvArray[2];
        this.therapeutic_indications = csvArray[3];
        this.dosage_normal = csvArray[4];
        this.dosage_30_50 = csvArray[5];
        this.dosage_10_30 = csvArray[6];
        this.extra = csvArray[7] === "1";
        this.classId = csvArray[8];
    }

    url(): string {
        return `/drug/${this.code}`;
    }

    render(): string {
        return "";
    }

    icon(): ReactNode {
        return <MedicationIcon />
    }

    id(): string {
        return `drug-${this.code}`;
    }

    bgColor(): string {
        return getAwareColor(this.classId);
    }
}

export class Drugs implements ItemManager<Drug> {
    private items: Drug[] = [];

    addItem(line: string[]) {
        const drug = new Drug(line);
        this.items.push(drug);
    }
    
    getItems(): Drug[] {
        return this.items.filter(item => !item.ref || isNaN(item.ref));
    }

    getById(id: number): Drug | undefined {
        return this.items.find(item => item.code === id);
    }

    getChildren(parentId: number): Drug[] {
        return this.items.filter(item => item.ref === parentId);
    }
}